
import React, { Component } from "react";
import {
  Badge,
  Col,
  ListGroupItem,
  Row,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ButtonGroup,
  Table
} from "reactstrap";
import { connect } from "react-redux";
import "./Recording.scss";
const apiCalls = require("../../ApiCalls");


class Recording extends Component {
  constructor(props) {
    super(props)
    this.getRecordingUrl = this.getRecordingUrl.bind(this)
    this.state = {
      recordingUrl: "",
      recordingExists: true
    };
  }
  componentDidMount() {
   this.getRecordingUrl()
  }

  getRecordingUrl()
  {
    
    if(this.props.match.params.conversationId && this.props.match.params.recId)
    {   
      apiCalls.getPrismMetadata(this.props.match.params.conversationId, this.props.match.params.recId).then((res)=>{
        try{
          this.setState({recordingUrl: `${apiCalls.getApiUrl()}/prism/stream?url=${res.data.url[0]._text}`})
        }
        catch{
         
          this.setState({recordingExists: false})
        }
        
      })
    }
    else{
      this.setState({recordingUrl: `${apiCalls.getApiUrl()}/messages/recordings/${this.props.match.params.recId}/stream`})
    }
  }

  render() {
    return (
      <div className="animated fadeIn full-height">
          <Row>
            <Col xs={{size: 4, offset:4}} className="player-col">
              <audio
                key={this.state.recordingUrl}
                controls
                controlsList="true"
                className="player full-width"
                preload="false"
                ref="audio"
              >
                <source src={this.state.recordingUrl} />
              </audio>
              <p className="audio-error" hidden={this.state.recordingExists}> Failed to retrieve audio</p>
            </Col>
          </Row>
      </div>
    );
  }
}

export default Recording;
